import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import PartnerDetail from './PartnerDetail.page';

import { getPartnerDetail, updatePartner } from '../../redux/actions/delivery';

const mapStateToProps = state => ({
  loading: state.delivery.loading,
  partnerDetail: state.delivery.partnerDetail,
});

const mapDispatchToProps = {
  getPartnerDetail,
  updatePartner,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PartnerDetail));
